// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] + "." + {"43":"9ae33f98","234":"5d34d0cc","653":"4fdb8761","844":"4cc59584"}[chunkId] + ".chunk.css";
};